export default [
  'Asia/Bangkok',
  'America/Toronto',
  'America/Denver',
  'America/Edmonton',
  'Africa/Abidjan',
  'Etc/GMT+6',
  'Etc/GMT-5',
  'Etc/GMT-3',
  'Pacific/Wake',
  'Australia/Sydney',
  'Australia/Melbourne',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Indian/Maldives',
  'Indian/Cocos',
  'Indian/Christmas',
  'Australia/Perth',
  'Australia/West',
  'Asia/Dubai',
  'Europe/Moscow',
  'Europe/Paris',
  'Europe/Copenhagen',
  'Europe/London',
  'Atlantic/Reykjavik',
  'Mexico/General',
  'America/Vancouver',
  'America/Anchorage',
  'America/Montreal',
  'America/Halifax',
  'US/Alaska',
  'Canada/Atlantic',
  'Canada/Central',
  'Canada/Eastern',
  'Canada/Mountain',
  'Canada/Newfoundland',
  'Canada/Pacific',
  'Canada/Saskatchewan',
  'Australia/Queensland',
  'Australia/North',
  'Australia/South',
  'Australia/Eucla',
  'Antarctica/Macquarie',
  'Australia/Brisbane',
  'Australia/Lindeman',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Pacific/Norfolk',
  'Pacific/Chatham',
  'Pacific/Auckland',
  'Australia/Broken_Hill',
  'Australia/Lord_Howe',
];
